import { Button } from 'antd';
import { styled } from 'styled-components';
import { Link } from 'react-router-dom';

type NavLinkProps = {
  color: string;
  fontSize?: string;
};

export const NavLogo = styled(Link)`
  flex: 0 0 auto;

  .app-logo {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
  }

  img {
    @media (max-width: 1439px) {
      max-width: 100px;
      height: auto;
    }

    @media (max-width: 767px) {
      display: block;
      width: auto;
      height: 22px;
      max-width: none;
      margin-left: 0;
      flex: 0 0 auto;
    }
  }

  svg {
    flex: 0 0 auto;

    @media (max-width: 767px) {
      width: 28px;
      height: 24px;
    }
  }
`;

export const HeaderTools = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  min-width: 0;
`;

export const MenuButton = styled(Button)`
  margin-left: auto;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  font-size: 20px;
`;

export const MobileMenuSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;

  .tenant-switcher-select.ant-select {
    width: 100% !important;
  }

  .ant-btn {
    width: 100%;
  }
`;

export const MobileActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
  padding-top: 8px;
  border-top: 1px solid #eef2f6;
`;

const mobileActionStyle = `
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 40px;
  padding: 8px 4px;
  border: 0;
  background: transparent;
  color: inherit;
  font-size: 16px;
  text-align: left;
  text-decoration: none;
  cursor: pointer;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const MobileActionLink = styled(Link)`
  ${mobileActionStyle}
`;

export const MobileActionButton = styled.button`
  ${mobileActionStyle}
`;

export const TenantSwitcherSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;

  &:empty {
    display: none;
  }
`;

export const NavActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const NavLinkDesktop = styled.span<NavLinkProps>`
  font-size: ${({ fontSize }) => fontSize || '40px'};
  line-height: 1;
  color: ${(props) => props.color};
  cursor: pointer;

  &:hover {
    color: #f5871f;
  }

  @media (max-width: 1439px) {
    font-size: 26px;
    padding: 5px;
  }

  @media (max-width: 767px) {
    font-size: 22px;
    padding: 4px;
  }
`;

export const NavLinkMobile = styled.span<NavLinkProps>`
  display: flex;
  font-size: 20px;
  color: ${(props) => props.color};
  border-top: 1px solid ${({ theme }) => theme.defaultLink};
  padding: 10px 5px;
`;

export const NavLinkLabelMobile = styled.div`
  margin-left: 10px;
  color: ${({ theme }) => theme.defaultLink};
  font-size: 18px;
`;

export const NavLinkContent = styled(Link)`
  text-decoration: none;
`;

export const NavCustomerLogo = styled.img`
  max-height: 56px;
  max-width: 167px;
  align-self: center;

  @media (max-width: 1320px) {
    max-width: 120px;
    max-height: 36px;
  }
`;
